export enum StripeAccountTypeCode{
    Individual = 0,
    Company = 1,
    None = 2,
}